module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_5012.388361f7.png";